import { connect } from 'react-redux';
import actions from '../redux/actions';
import Intake from '../components/intake';
import { canSignUpForDeployment } from 'util/user';

// state is object that holds reducers from combineReducers and hence the state in them
function mapStateToProps(state: any) {
    const { getApiError, getApiErrorResponse } = state.error;
    const { debitCardOptions, debitInfo } = state.debitCard;
    const { homelesses } = state.homelesses;
    const {
        fromIntakeAutofill,
        intakeAgreed,
        intakeBeaconId,
        intakeBirthDay,
        intakeEmail,
        intakeGoals,
        intakeGuideSteps,
        intakeGuideMessages,
        intakeIcebreaker,
        intakeId,
        intakeIsSubmitted,
        intakeIsSubmitting,
        intakeNeeds,
        intakePhoneNo,
        intakePrivateFirstName,
        intakePrivateFullName,
        intakePrivateLastName,
        intakePrivateMiddleName,
        intakeProfilePic,
        intakeProfileName,
        intakeProgressWidth,
        intakeQuestionsAndAnswers,
        intakeRelevantId,
        intakeLanguagePreference,
        intakeStep,
        intakeTouchpoints,
        intakeTouchpointIsSubmitting,
        intakeTouchpointIsSubmitted,
        maxIntakeStep,
        minIntakeStep
    } = state.intake;
    const { layoutTitles } = state.samaritan;
    const { touchpointQuestions, isFetchingTouchpointQuestions } =
        state.touchpointQuestions;
    const { maxBonusAmount } = state.user;
    const {
        email,
        id,
        is_showing_intake_guides,
        members_enrolled,
        name,
        partner
    } = state.user.user;
    const {
        deployments,
        deployment_id,
        id: org_id,
        intake_steps
    } = state.user.user.partner || [];

    const { user } = state.user;

    const intakeDeploymentId = (() => {
        // If already set/available, use it
        if (state.intake.intakeDeploymentId !== undefined && state.intake.intakeDeploymentId !== null && state.intake.intakeDeploymentId !== '') {
            return state.intake.intakeDeploymentId;
        }
        
        // Auto-select if only one deployment and it's open
        if (state.user.user.partner.deployments.length === 1) {
            const deployment = state.user.user.partner.deployments[0];
            if (canSignUpForDeployment(deployment).canSignUp) {
                return deployment.id;
            }
        }
        
        return ''; 
    })();

    return {
        ctpEmail: email,
        ctpId: id,
        ctpName: name,
        user: user,
        ctpPartner: partner,
        debitCardOptions,
        debitInfo,
        deployments,
        deployment_id,
        fromIntakeAutofill,
        getApiError,
        getApiErrorResponse,
        homelesses,
        intakeAgreed,
        intakeBeaconId,
        intakeBirthDay,
        intakeDeploymentId,
        intakeEmail,
        intakeGoals,
        intakeGuideMessages,
        intakeGuideSteps,
        intakeIcebreaker,
        intakeId,
        intakeIsSubmitted,
        intakeIsSubmitting,
        intakeNeeds, // TODO: Remove this
        intakePhoneNo,
        intakePrivateFirstName,
        intakePrivateFullName,
        intakePrivateLastName,
        intakePrivateMiddleName,
        intakeProfileName,
        intakeProfilePic,
        intakeProgressWidth,
        intakeQuestionsAndAnswers,
        intakeRelevantId,
        intakeLanguagePreference,
        intakeStep,
        intakeTouchpointIsSubmitted,
        intakeTouchpointIsSubmitting,
        intakeTouchpoints,
        intake_steps,
        isFetchingTouchpointQuestions,
        is_showing_intake_guides,
        layoutTitles,
        maxBonusAmount,
        maxIntakeStep,
        members_enrolled,
        minIntakeStep,
        orgId: org_id,
        touchpointQuestions
    };
}

const mapDispatchToProps = {
    decrementStep: actions.decrementIntakeStep,
    getDebitCardOptions: actions.fetchDebitCardOptionsRequest,
    getTouchpointQuestions: actions.getTouchpointQuestionsRequest,
    incrementStep: actions.incrementIntakeStep,
    resetError: actions.resetApiError,
    resetIntake: actions.resetIntake,
    setIntakeBeaconId: actions.setIntakeBeaconId,
    setIntakeBirthDay: actions.setIntakeBirthDay,
    setIntakeDeploymentId: actions.setIntakeDeploymentId,
    setIntakeEmail: actions.setIntakeEmail,
    setIntakeGoals: actions.setIntakeGoals,
    setIntakeIcebreaker: actions.setIntakeIcebreaker,
    setIntakePhoneNo: actions.setIntakePhoneNo,
    setIntakePrivateFirstName: actions.setIntakePrivateFirstName,
    setIntakePrivateFullName: actions.setIntakePrivateFullName,
    setIntakePrivateLastName: actions.setIntakePrivateLastName,
    setIntakePrivateMiddleName: actions.setIntakePrivateMiddleName,
    setIntakeProfileName: actions.setIntakeProfileName,
    setIntakeProfilePicUrl: actions.setIntakeProfilePicUrl,
    setIntakeRelevantId: actions.setIntakeRelevantId,
    setIntakeLanguagePreference: actions.setIntakeLanguagePreference,
    setIntakeTouchpoints: actions.setIntakeTouchpointAnswer,
    setLayoutTitles: actions.setLayoutTitles,
    setViewGuideMessage: actions.setViewGuideMessage,
    submitIntake: actions.submitIntake,
    submitIntakeTouchpoint: actions.submitIntakeTouchpoint,
    toggleIntakeAgreed: actions.toggleIntakeAgreed,
    updateUserSettings: actions.updateUserSettings
};

// TODO: Fix any types
export default connect(mapStateToProps, mapDispatchToProps)(Intake as any);
